import Link from 'next/link';

import useI18n from '@i18n';

import routes from '@config/routes.json';
import OffersSlider from '@components/pages/placements/OffersSlider';

import styles from './styles.module.scss';
import { IPlacementOffersProps } from '../../interfaces';

const PlacementOffers: React.FC<IPlacementOffersProps> = ({
    formData,
    isSocialOrWebsite,
    offers,
    isLoadingOffers,
    totalOffers,
    onNextOffers,
}) => {
    const { t, locale } = useI18n('Placements');
    const { t: tCommon } = useI18n('Common');

    return (
        <div>
            <OffersSlider
                offers={offers}
                titleClassName={!isSocialOrWebsite ? styles.mainTitle : ''}
                title={
                    formData?.offer
                        ? t('Other offers suitable for traffic source:')
                        : t('Offers that suit your traffic source')
                }
                totalOffers={totalOffers}
                isLoadingOffers={isLoadingOffers}
                onNextOffers={onNextOffers}
                loadMore
            />
            <div>
                <div className={styles.alert}>
                    {!formData?.offer && (
                        <p className="mb-4">
                            {t(
                                'Your traffic source will be automatically submitted when you connect to the AliExpress offer',
                            )}
                        </p>
                    )}
                    <p>
                        {t(
                            'After sending traffic source for verification, you can start working with other offers, to do this, click on the',
                        )}{' '}
                        <span className="underline text-blueGray-800">
                            &quot;{tCommon('Connect')}&quot;
                        </span>{' '}
                        {t('button on the card in the')} &quot;
                        <Link
                            href={`/${locale}${routes.offers}`}
                            className="underline text-blueGray-800"
                        >
                            {t('Offers')}
                        </Link>
                        &quot;
                        {locale === 'en' && ` ${t('section')}`}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PlacementOffers;
